<template>
  
  <div>
    <caixa-modal-component></caixa-modal-component>
    
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Caixas do dia {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
          </div>
          <div class="row">
            
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_fim">
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
          </div>


          <div class="mb-3">
            <div v-for="caixa of caixas" class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-10">
                <strong>{{ caixa.data_abertura | moment('DD/MM/YYYY - HH:mm')  }}</strong>
                <br>
                <strong>{{ caixa.data_fechamento | moment('DD/MM/YYYY - HH:mm')  }}</strong>
                <br>
                <p class="m-0 mt-2 ">Total Vendas: {{ caixa.total_vendas | currencyBrl(false) }}</p>
                V. Abertura: {{ caixa.valor_abertura | currencyBrl(false) }}
                <br>
                V. Fechamento: {{ caixa.valor_fechamento | currencyBrl(false)}}
                <br>
                Diferença: {{ caixa.diferenca_fechamento | currencyBrl(false)}}
              </div>

              <div class="col-2">
                <button class="btn btn-sm btn-info px-2 py-1" @click="openCaixaModal(caixa)" style="font-size: 10px"><i class="fa fa-info"></i></button>
              </div>
            </div>
          </div>

          <table class="display responsive nowrap table table-hover table-striped table-bordered hidden-mobile">
            <thead>
              <tr>
                <th>Código</th>
                <th class="text-right">Valor Abertura</th>
                <th class="text-right pr-4">Valor Fechamento</th>
                <th class="text-right">Diferença de Caixa</th>
                <th class="text-center">Data Início</th>
                <th class="text-center">Data Término</th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="caixa of caixas">
                <td>{{ caixa.codigo }}</td>
                <td class="text-right">{{ caixa.valor_abertura | currencyBrl(true) }}</td>
                <td class="text-right pr-3">{{ caixa.valor_fechamento | currencyBrl(true) }}</td>
                <td class="text-right">{{ caixa.diferenca_fechamento | currencyBrl(true) }}</td>
                <td class="text-center">{{ caixa.data_abertura | moment("DD/MM/YY HH:mm") }}</td>
                <td class="text-center">{{ caixa.data_fechamento | moment("DD/MM/YY HH:mm") }}</td>
                <td class="text-right">
                  <button class="btn btn-sm btn-info px-2 py-1 f-10" @click="openCaixaModal(caixa)"><i class="fa fa-info"></i></button>
                </td>
              </tr>
              <tr v-if="!caixas || !caixas.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-12 col-md-6 text-center-mobile">
              Mostrando de {{ from }} até {{ to }} de {{ total}} registros
            </div>
            <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
              <paginate
                :pageCount="pageCount"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
import moment from 'moment'
import CaixaService from '@/services/CaixaService.js'
import CaixaModalComponent from '@/components/Modals/CaixaModalComponent.vue'

export default {
    components: {
      CaixaModalComponent,
      Card,
      moment,
    },
    data() {
      return {
        data_inicio: moment().subtract(7, 'days').format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().subtract(7, 'days').format("DD/MM/YYYY"),
        chartData: [100, 150, 100, 190, 130, 90, 150, 160, 120, 140, 190, 95],
        chartLabels: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'],

        caixas: [],

        from: 0,
        to: 0,
        total: 0,
      

        current_page: 1,
        pageCount: 0,
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.loadCaixas()
      },

      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadCaixas()
      },
      loadCaixas() {
        let loader = this.$loading.show()

        CaixaService.load(`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}`).then(res => {
          this.pageCount = res.data.last_page
          this.caixas = res.data.data
          this.from = res.data.from
          this.to = res.data.to
          this.total = res.data.total
          loader.hide()
        }).catch(err => {
          loader.hide()
        })
      },

      openCaixaModal(caixa) {

        this.$modal.show('caixa-modal-component', { caixa: caixa })
      }
    },
    mounted() {
      this.loadCaixas()
    }
}
</script>